import { render, staticRenderFns } from "./Enhanced_focus_deep.vue?vue&type=template&id=af8c4154"
import script from "./Enhanced_focus_deep.vue?vue&type=script&lang=js"
export * from "./Enhanced_focus_deep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports